import React, {useEffect, useState} from 'react';
import { Form } from 'react-bootstrap';
import { fetchStores, setActiveStore, fetchCurrentStore} from "../api/api";

const StoreSelector = () => {
    const [stores, setStores] = useState([]);
    const [activeStore, setActiveStoreState] = useState(null);

    useEffect(() => {
        loadStores();
        loadCurrentStore();
    }, []);

    const loadStores = async () => {
        const data = await fetchStores();
        setStores(data);
    };

    const loadCurrentStore = async () => {
        try {
            const store = await fetchCurrentStore();
            setActiveStoreState(store.id);

            if (store?.name) {
                localStorage.setItem('active_store_name', store.name);
            }
            if (store?.id != null) {
                localStorage.setItem('active_store_id', String(store.id));
            }
        } catch {
            console.log('No active store yet');
        }
    };

    const handleChange = async (e) => {
        const storeId = e.target.value;
        await setActiveStore(storeId);
        setActiveStoreState(storeId);

        // save the store name to local storage to be used in the login page (login.js)
        const selected = stores.find((s) => String(s.id) === String(storeId));
        if (selected?.name) {
            localStorage.setItem('active_store_name', selected.name);
        }
        if (storeId) {
            localStorage.setItem('active_store_id', String(storeId));
        }

        // refresh page so request.store updates everywhere
        window.location.reload();
    };

    return (
        <div className="d-flex align-items-center me-3">
            <Form.Select
                size="sm"
                value={activeStore || ""}
                onChange={handleChange}
                style={{
                    width: "180px",
                    border: "1px solid #198754",
                    backgroundColor: "#f8fff9",
                    fontWeight: "500"
                }}
            >
                <option value="">Select Store</option>

                {stores.map(store => (
                    <option key={store.id} value={store.id}>
                        {store.name}
                    </option>
                ))}
            </Form.Select>
        </div>
    );
};

export default StoreSelector;